export default {
    title: 'Löschen',
    deleteAction: 'Keine Beschaffung löschen | {count} Beschaffung löschen | {count} Beschaffungen löschen',
    reallyDelete: 'Möchten Sie die ausgewählten Beschaffungen wirklich löschen?',
    deletedOrders: 'Die Beschaffungen wurden gelöscht.'
}